/* eslint-disable */

import Vue from 'vue';
import fastdom from 'fastdom';
import UAParser from 'ua-parser-js';

import store from './store';
import * as mutationTypes from './store/mutation-types';

import { GLOBAL_MEDIA } from './utils';

/**
 * IF we are in an iframe
 *
 * @type {Boolean} true if we are in the iframe
 */
const inFrame = window.parent !== window;

/**
 * Sniffs the UA
 *
 * @type {UAParser}
 */
var parser = new UAParser();

/**
 * Application events
 *
 * @name MediaListeners
 */
const mediaListeners = new Vue({
  data: {
    mql: {
      xlarge: null,
      large: null,
      medium: null,
      small: null,
    },
    innerWidth: 0,
    innerHeight: 0,
    icbWidth: 0,
    icbHeight: 0,
    scrollY: 0, // for scroll direction update
    // TODO: fix, this isn't the rignt window...
    $_mediaListeners_initialContainingBlockEl: window.document && window.document.documentElement,
  },
  computed: {
    viewportHeight() {
      return this.icbHeight || this.innerHeight;
    },
    viewportWidth() {
      return this.icbWidth || this.innerWidth;
    }
  },
  created() {
    // setup media queries
    this.mql.xlarge = window.matchMedia(GLOBAL_MEDIA['x-large']);
    this.mql.large = window.matchMedia(GLOBAL_MEDIA.large);
    this.mql.medium = window.matchMedia(GLOBAL_MEDIA.medium);
    this.mql.small = window.matchMedia(GLOBAL_MEDIA.small);

    this.mql.xlarge.addListener(this.setMediaXlarge);
    this.mql.large.addListener(this.setMediaLarge);
    this.mql.medium.addListener(this.setMediaMedium);
    this.mql.small.addListener(this.setMediaSmall);

    this.setMediaXlarge(this.mql.xlarge);
    this.setMediaLarge(this.mql.large);
    this.setMediaMedium(this.mql.medium);
    this.setMediaSmall(this.mql.small);

    window.addEventListener('resize', this.handleResize);
    this.handleResize(window);

    window.addEventListener('scroll', this.handleScroll);

    store.commit(mutationTypes.WINDOW_MEDIA_SET_DEVICE_TYPE, {
      device: parser.getDevice(),
    })
    store.commit(mutationTypes.WINDOW_MEDIA_SET_OS, {
      os: parser.getOS(),
    })
    store.commit(mutationTypes.WINDOW_MEDIA_SET_BROWSER, {
      browser: parser.getBrowser(),
    })
  },
  beforeDestroy() {
    // tear down media query listeners
    this.mql.desktop.removeListener(this.setMediaXlarge);
    this.mql.landscape.removeListener(this.setMediaLarge);
    this.mql.xxshort.removeListener(this.setMediaMedium);
    this.mql.xxshort.removeListener(this.setMediaSmall);

    // resize
    window.removeEventListener('resize', this.handleResize);
    // scroll
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    /**
     * Update media flags in store
     *
     * @param {MediaQueryList} mql media query list to respond to
     */
    setMediaXlarge({ matches }) {
      store.commit(mutationTypes.WINDOW_MEDIA_SET_MEDIA_XLARGE, { matches });
    },

    setMediaLarge({ matches }) {
      store.commit(mutationTypes.WINDOW_MEDIA_SET_MEDIA_LARGE, { matches });
    },

    setMediaMedium({ matches }) {
      store.commit(mutationTypes.WINDOW_MEDIA_SET_MEDIA_MEDIUM, { matches });
    },

    setMediaSmall({ matches }) {
      store.commit(mutationTypes.WINDOW_MEDIA_SET_MEDIA_SMALL, { matches });
    },

    updateWindowSize() {
      let icbHeight = 0;
      let icbWidth = 0;
      let innerWidth;
      let innerHeight;

      fastdom.measure(() => {
        ({ innerHeight, innerWidth } = window);
        if (this.$_mediaListeners_initialContainingBlockEl) {
          // in case you're not in a window for some reason...
          ({
            height: icbHeight,
            width: icbWidth
          } = this.$_mediaListeners_initialContainingBlockEl.getBoundingClientRect());
        }
      });

      fastdom.mutate(() => {
        this.innerHeight = innerHeight;
        this.innerWidth = innerWidth;
        this.icbHeight = icbHeight;
        this.icbWidth = icbWidth;

        if (!inFrame) {
          store.commit(mutationTypes.WINDOW_MEDIA_SET_SIZE, {
            innerWidth,
            innerHeight,
            icbWidth,
            icbHeight,
          });
        }
      });
    },

    updateScroll() {
      let scrollY;
      let pageYOffset;
      fastdom.measure(() => {
        ({ scrollY, pageYOffset } = window);
      });
      fastdom.mutate(() => {
        this.$_mediaListeners_windowScrollY = scrollY || pageYOffset;
        if (!inFrame) {
          store.commit(mutationTypes.WINDOW_MEDIA_SET_SCROLL_TOP, { scrollY: scrollY || pageYOffset });
        }
      });
    },

    handleResize() {
      this.updateWindowSize();
    },
  },
  watch: {
  },
});

export default mediaListeners;
